import params from '../../../setup/config/params.json';
import QrDining from '../index';
import CreateOrUpdateTable from '../components/CreateOrUpdateTable';

const routes = {
    qrTableList: {
        path: '/qr-dining',
        component: QrDining,
        exact: true,
        auth: true,
        role: params.user.roles.admin.key,
        module: "store",
        subModule: "qrDining",
        action: "canView",
    },
    createorUpdate: {
        path: '/qr-dining/createOrUpdate',
        component: CreateOrUpdateTable,
        exact: true,
        auth: true,
        role: params.user.roles.admin.key,
        module: "store",
        subModule: "qrDining",
        action: "canView",
    }    
}

export default routes